import { Component, Input, OnInit, Output, EventEmitter, SimpleChanges } from "@angular/core";
import { ImageCroppedEvent, ImageTransform } from "ngx-image-cropper";

@Component({
  selector: "app-imageCropper",
  templateUrl: "./imageCropper.html",
  styleUrls: ["./imageCropper.scss"]
})
export class ImageCropperComponent implements OnInit {
  @Input("url") url: any = "";
  @Output("setbase64") setbase64 = new EventEmitter();
  @Input("type") type = "base64";
  @Input("size") size = 1;
  @Input("rounded") rounded = true;
  @Input() colorText = "";
  @Input() aspectRatio = 1 / 1;

  containWithinAspectRatio = false;
  imageChangedEvent: any = "";
  croppedImage: any = "";
  file: any;

  defaultImage: String = "assets/img/dummy.png";
  showCropp = false;
  canvasRotation = 0;
  scale = 0;
  transform: ImageTransform = {
    scale: 0,
    flipH: false,
    flipV: false
  };

  constructor() {}

  ngOnInit(): void {}
  cropperReady(event) {}

  fileChangeListener(event) {
    this.file = event.target.files[0];
    this.imageChangedEvent = event;
    this.showCropp = true;
  }

  imageCropped = async (event: ImageCroppedEvent) => {
    let base64 = await event.base64;
    this.url = base64;

    this.setbase64.emit(this.type === "base64" ? event.base64 : this.dataURLtoFile(event.base64));
  };
  loadImageFailed() {}

  LoadedImage(event) {}
  dataURLtoFile(base64Image) {
    const split = base64Image.split(",");
    const type = split[0].replace("data:", "").replace(";base64", "");
    const byteString = atob(split[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i += 1) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type });
  }
  checkImage = async (url) => {
    const res = await fetch(url);
    const buff = await res.blob();

    return buff.type.startsWith("image/");
  };

  toggleContainWithinAspectRatio() {
    this.containWithinAspectRatio = !this.containWithinAspectRatio;
  }
  imageLoaded() {}
  rotateLeft() {
    this.canvasRotation--;
    this.flipAfterRotate();
  }

  rotateRight() {
    this.canvasRotation++;
    this.flipAfterRotate();
  }

  private flipAfterRotate() {
    const flippedH = this.transform.flipH;
    const flippedV = this.transform.flipV;
    this.transform = {
      ...this.transform,
      flipH: flippedV,
      flipV: flippedH
    };
  }
  flipHorizontal() {
    this.transform = {
      ...this.transform,
      flipH: !this.transform.flipH
    };
  }

  flipVertical() {
    this.transform = {
      ...this.transform,
      flipV: !this.transform.flipV
    };
  }
  zoomOut() {
    this.scale -= 0.1;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  zoomIn() {
    this.scale += 0.1;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }
  returnImage() {
    return this.url ? this.url : "assets/img/dummy.png";
  }

  /**
   * Devuelve el estilo inline del contenedor de la imagen de vista previa.
   * Calcula el alto dinamicamente a partir del `aspectRatio` y aplica
   * `border-radius: 50%` solo cuando la imagen es cuadrada y `rounded` es verdadero.
   * @returns Objeto de estilos CSS.
   */
  getPreviewLabelStyle(): object {
    const baseWidth = this.size === 1 ? 137 : 200;
    const height = Math.round(baseWidth / this.aspectRatio);
    const isCircle = this.rounded && this.aspectRatio === 1;
    return {
      height: `${height}px`,
      "border-radius": isCircle ? "50%" : "4px"
    };
  }

  /**
   * Devuelve el mapa de clases CSS para el elemento `<img>` de vista previa.
   * Aplica `rounded-circle` unicamente cuando el aspecto es 1:1 y `rounded` es verdadero.
   * @returns Objeto con clases CSS y sus estados booleanos.
   */
  getImageClass(): object {
    return {
      "img-fluid": true,
      "img-thumbnail": true,
      "label-size": true,
      "rounded-circle": this.rounded && this.aspectRatio === 1
    };
  }
}
